module.exports = "/build/web/svg/sponsor/molecaten_new.79eef2d514a51e13a2671010be5af904.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/sponsor/molecaten_new.svg
// module id = 218
// module chunks = 24